const ROLE_META = {
  DWSUser: { title: "DWS user", code: "DWS", group: "Gate" },
  PortalUser: { title: "Portal user", code: "Portal", group: "Gate" },
  CustomerEntry_Management: { title: "Customer Entry", code: "CE1", group: "Customer Entry" },
  CustomerEntry_FullManagement: { title: "Customer Entry (full)", code: "CE2", group: "Customer Entry" },
  Claims_InvoicePreClaim: { title: "Claims", code: "CL1", group: "Claims" },
  Claims_FullManagement: { title: "Claims (XML)", code: "CL2", group: "Claims" },
  Claims_FullManagementWithdrawal: { title: "Claims (withdraw)", code: "CL3", group: "Claims" },
  Finance_ViewOnly: { title: "Finance (read only)", code: "FI1", group: "Finance" },
  Finance_CreateProcess: { title: "Finance (create)", code: "FI2", group: "Finance" },
  Finance_FinalizeSend: { title: "Finance (finalize)", code: "FI3", group: "Finance" },
  Sales_ViewOnly: { title: "Sales (read only)", code: "SA1", group: "Sales" },
  Sales_EditAccess: { title: "Sales (edit)", code: "SA2", group: "Sales" },
  Administration_Roles: { title: "Administration", code: "AD1", group: "Administration" },
  Administration_Extended: { title: "Administration (extended)", code: "AD2", group: "Administration" },
  Admin: { title: "Admin", code: "Admin", group: "Legacy" },
  DWSManager: { title: "DWS Manager", code: "Mgr", group: "Legacy" },
  AllowPreFinance: { title: "Allow PreFinance", code: "VF", group: "Legacy" },
};

const GROUP_ORDER = [
  "Gate",
  "Customer Entry",
  "Claims",
  "Finance",
  "Sales",
  "Administration",
  "Legacy",
  "Custom",
];

const GROUP_COLORS = {
  Gate: "#546e7a",
  "Customer Entry": "#00897b",
  Claims: "#1976d2",
  Finance: "#2e7d32",
  Sales: "#ed6c02",
  Administration: "#6a1b9a",
  Legacy: "#6d4c41",
  Custom: "#455a64",
};

export const getRoleMeta = (roleName) => {
  const known = ROLE_META[roleName];
  if (known) {
    return known;
  }

  return { title: roleName, code: "Custom", group: "Custom" };
};

const ROLE_SORT_INDEX = Object.keys(ROLE_META).reduce((map, name, index) => {
  map[name] = index;
  return map;
}, {});

const getCodeLevel = (code) => {
  const match = String(code || "").match(/(\d+)$/);
  return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
};

const compareRolesInGroup = (a, b) => {
  const levelA = getCodeLevel(a.meta?.code);
  const levelB = getCodeLevel(b.meta?.code);
  if (levelA !== levelB) {
    return levelA - levelB;
  }

  const indexA = ROLE_SORT_INDEX[a.name] ?? Number.MAX_SAFE_INTEGER;
  const indexB = ROLE_SORT_INDEX[b.name] ?? Number.MAX_SAFE_INTEGER;
  if (indexA !== indexB) {
    return indexA - indexB;
  }

  return (a.meta?.title || a.name || "").localeCompare(b.meta?.title || b.name || "");
};

export const groupRoles = (roles) => {
  const buckets = new Map(GROUP_ORDER.map((group) => [group, []]));

  (roles || []).forEach((role) => {
    const meta = getRoleMeta(role.name);
    if (!buckets.has(meta.group)) {
      buckets.set(meta.group, []);
    }
    buckets.get(meta.group).push({ ...role, meta });
  });

  return GROUP_ORDER.map((group) => ({
    group,
    color: GROUP_COLORS[group],
    roles: (buckets.get(group) || []).slice().sort(compareRolesInGroup),
  })).filter((section) => section.roles.length > 0);
};

export const PERMISSION_LEVELS = [
  {
    value: "—",
    short: "—",
    label: "None",
    color: "#78909c",
    background: "transparent",
  },
  {
    value: "R",
    short: "R",
    label: "View",
    color: "#1565c0",
    background: "rgba(21, 101, 192, 0.08)",
  },
  {
    value: "W",
    short: "W",
    label: "Edit",
    color: "#ef6c00",
    background: "rgba(239, 108, 0, 0.10)",
  },
  {
    value: "X",
    short: "X",
    label: "Action",
    color: "#6a1b9a",
    background: "rgba(106, 27, 154, 0.10)",
  },
];
